import { C_DROPDOWN_HOVER, C_ON_SALES_CAMPAIGN, C_ON_SURFACE, C_SALES_CAMPAIGN } from "~/common/components/icon/Colors";

type Variant = "active" | "inactive";
interface Props {
  className?: string;
  variant?: Variant;
  size?: number;
  inverse?: boolean;
}

const getImageColor = (color: Variant) => {
  switch (color) {
    case "active":
      return C_SALES_CAMPAIGN;
    case "inactive":
      return C_DROPDOWN_HOVER;
  }
};
const getTextColor = (color: Variant) => {
  switch (color) {
    case "active":
      return C_ON_SALES_CAMPAIGN;
    case "inactive":
      return C_ON_SURFACE;
  }
};

export const SaleTag = ({ className, variant = "active", size = 48, inverse }: Props) => {
  const imageColor = getImageColor(variant);
  const textColor = getTextColor(variant);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M46.584 22.992L24.984 1.392C24.12 0.528 22.92 0 21.6 0H4.8C2.16 0 0 2.16 0 4.8V21.6C0 22.92 0.528 24.12 1.416 25.008L23.016 46.608C23.88 47.472 25.08 48 26.4 48C27.72 48 28.92 47.472 29.784 46.584L46.584 29.784C47.472 28.92 48 27.72 48 26.4C48 25.08 47.448 23.856 46.584 22.992ZM8.4 12C6.408 12 4.8 10.392 4.8 8.4C4.8 6.408 6.408 4.8 8.4 4.8C10.392 4.8 12 6.408 12 8.4C12 10.392 10.392 12 8.4 12Z"
        fill={inverse ? textColor : imageColor}
      />
      <path
        d="M15.5996 19.534C15.5996 18.1995 15.894 17.2104 16.4827 16.5669C17.0783 15.9233 17.8827 15.6016 18.8959 15.6016C19.9434 15.6016 20.7615 15.9233 21.3502 16.5669C21.9458 17.2037 22.2436 18.1927 22.2436 19.534C22.2436 20.8685 21.9458 21.8575 21.3502 22.5011C20.7615 23.1446 19.9605 23.4664 18.9473 23.4664C17.8999 23.4664 17.0783 23.148 16.4827 22.5112C15.894 21.8677 15.5996 20.8753 15.5996 19.534ZM17.8485 19.5137C17.8485 20.4824 17.9615 21.1327 18.1874 21.4646C18.3585 21.7085 18.5947 21.8304 18.8959 21.8304C19.204 21.8304 19.4436 21.7085 19.6148 21.4646C19.8338 21.1327 19.9434 20.4824 19.9434 19.5137C19.9434 18.5449 19.8338 17.898 19.6148 17.5729C19.4436 17.3222 19.204 17.1969 18.8959 17.1969C18.5947 17.1969 18.3585 17.3188 18.1874 17.5627C17.9615 17.8946 17.8485 18.5449 17.8485 19.5137ZM21.0935 31.3211H18.9576L26.9776 15.6016H29.0519L21.0935 31.3211ZM25.7556 27.409C25.7556 26.0745 26.05 25.0854 26.6387 24.4419C27.2343 23.7983 28.0456 23.4766 29.0725 23.4766C30.1062 23.4766 30.9175 23.7983 31.5062 24.4419C32.1018 25.0854 32.3996 26.0745 32.3996 27.409C32.3996 28.7503 32.1018 29.7427 31.5062 30.3862C30.9175 31.0298 30.1165 31.3516 29.1033 31.3516C28.0558 31.3516 27.2343 31.0298 26.6387 30.3862C26.05 29.7427 25.7556 28.7503 25.7556 27.409ZM28.0045 27.3988C28.0045 28.3675 28.1175 29.0145 28.3434 29.3396C28.5145 29.5903 28.7507 29.7156 29.0519 29.7156C29.36 29.7156 29.5962 29.5937 29.7605 29.3498C29.9864 29.0179 30.0994 28.3675 30.0994 27.3988C30.0994 26.4301 29.9898 25.7798 29.7708 25.4479C29.5996 25.204 29.36 25.082 29.0519 25.082C28.7439 25.082 28.5077 25.204 28.3434 25.4479C28.1175 25.7798 28.0045 26.4301 28.0045 27.3988Z"
        fill={inverse ? imageColor : textColor}
      />
    </svg>
  );
};
